<template>
  <div class="statistic_container">
    <ul class="statistic-content" v-if="!isLoaded">
      <li class="statistic-content__item statistic-content__item--common">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{total}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.commonTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.commonTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                100%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item, key) in totalArr" :key="key">
            <td class="source-statistic__table-col-source">
              <el-checkbox
                :value="socialList.includes(key)"
                :checked="socialList.includes(key)"
                @change="changeSocialList(key)"
              >
                {{item.name}}
              </el-checkbox>
            </td>
            <td class="source-statistic__table-col">
              {{item.sum != 0 ? ((item.sum/total)*100).toFixed(2) : 0}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>

        </table>
      </li>
      <li class="statistic-content__item statistic-content__item--neutral">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{netural}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.neutralTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.neutralTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                {{netural!= 0 ? ((netural/total)*100).toFixed(2) : 0}}%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item,key) in neturalArr" :key="key">
            <td class="source-statistic__table-col-source">
              {{item.name}}
            </td>
            <td class="source-statistic__table-col">
              {{item.sum != 0 ? ((item.sum/netural)*100).toFixed(2) : 0}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>
      <li class="statistic-content__item statistic-content__item--positive">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{positive}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.positiveTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.positiveTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                {{positive!= 0 ? ((positive/total)*100).toFixed(2) : 0}}%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item,key) in positiveArr" :key="key">
            <td class="source-statistic__table-col-source">
              {{item.name}}
            </td>
            <td class="source-statistic__table-col">
              {{item.sum != 0 ? ((item.sum/positive)*100).toFixed(2) : 0}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>

      <li class="statistic-content__item statistic-content__item--negative">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{negative}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.negativeTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.negativeTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                {{negative!= 0 ? ((negative/total)*100).toFixed(2) : 0}}%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item,key) in negativeArr" :key="key">
            <td class="source-statistic__table-col-source">
              {{item.name}}
            </td>
            <td class="source-statistic__table-col">
              {{item.sum != 0 ? ((item.sum/negative)*100).toFixed(2) : 0}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>
    </ul>
    <ul class="statistic-content" v-if="isLoaded">
      <li class="statistic-content__item statistic-content__item--common">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{totalSum}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.commonTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.commonTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                100%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item, key) in totalData" :key="key">
            <td class="source-statistic__table-col-source">
              <el-checkbox
                :value="socialList.includes(key)"
                :checked="socialList.includes(key)"
                @change="changeSocialList(key)"
              >
                {{item.name}}
              </el-checkbox>
            </td>
            <td class="source-statistic__table-col">
              {{item.percent}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>

      <li class="statistic-content__item statistic-content__item--neutral">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{neturalSum}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.neutralTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.neutralTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                {{getTotalPercent(neturalSum)}}%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item,key) in neturalData" :key="key">
            <td class="source-statistic__table-col-source">
              {{item.name}}
            </td>
            <td class="source-statistic__table-col">
              {{item.percent}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>

      <li class="statistic-content__item statistic-content__item--positive">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{positiveSum}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.positiveTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.positiveTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                {{getTotalPercent(positiveSum)}}%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item,key) in positiveData" :key="key">
            <td class="source-statistic__table-col-source">
              {{item.name}}
            </td>
            <td class="source-statistic__table-col">
              {{item.percent}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>

      <li class="statistic-content__item statistic-content__item--negative">
        <table class="source-statistic__table">
          <tr class="source-statistic__table-row">
            <td class="source-statistic__table-col-header">
              <p class="statistic-content__count">
                {{negativeSum}}
              </p>
              <span class="statistic-content__title">
                {{$t('feed.analytics.statistics.body.negativeTitle[0]')}}<br> {{$t('feed.analytics.statistics.body.negativeTitle[1]')}}
              </span>
            </td>
            <td class="source-statistic__table-col-header">
              <span class="statistic-content__percent">
                {{getTotalPercent(negativeSum)}}%
              </span>
            </td>
            <td></td>
          </tr>

          <tr class="source-statistic__table-row" v-for="(item,key) in negativeData" :key="key">
            <td class="source-statistic__table-col-source">
              {{item.name}}
            </td>
            <td class="source-statistic__table-col">
              {{item.percent}}%
            </td>
            <td class="source-statistic__table-col-count">
              {{item.sum}}
            </td>
          </tr>
        </table>
      </li>
    </ul>
    <ul class="statistic_control">
      <li class="statistic_control__item" @click="setStatisticItem('prev')">
        <i class="material-icons">
          navigate_before
        </i>
      </li>
      <li class="statistic_control__item" @click="setStatisticItem('next')">
        <i class="material-icons">
          navigate_next
        </i>
      </li>
    </ul>
  </div>
</template>

<script>
// config
import sourceShortcuts from "../../../../../../../../config/sourceShortcuts";

// vuex
import { mapGetters } from "vuex";

import {SET_SOCIAL} from "../../../../../../../../store/actions/social";
import { getTrustHourlyApi } from "../../../../../../../../api/stats"
import moment from "moment";

export default {
  name: "StatisticBody",
  props: {
    data: {
      type: Object,
      required: true
    },
    chartName: {
      type: String
    },
  },
  data() {
    return {
      activeStatisticItem: 0,
      total: 0,
      dataFb: {
        positive: 0,
        negative: 0,
        netural: 0,
        total: 0
      },
      totalArr: {
        vk: {
          name: 'Вконтакте',
          persent: 0,
          sum: 0
        },
        fb: {
          name: 'Facebook',
          persent: 0,
          sum: 0
        },
        tw: {
          name: 'Twitter',
          persent: 0,
          sum: 0
        },
        ig: {
          name: 'Instagram',
          persent: 0,
          sum: 0
        },
        tg: {
          name: 'Telegram',
          persent: 0,
          sum: 0
        },
        yt: {
          name: 'Yotube',
          persent: 0,
          sum: 0
        },
        ok: {
          name: 'Одноклассники',
          persent: 0,
          sum: 0
        },
        dz: {
          name: 'Блоги',
          persent: 0,
          sum: 0
        },
        gs: {
          name: 'СМИ',
          persent: 0,
          sum: 0
        },
      },
      positiveArr: {
        vk: {
          name: 'Вконтакте',
          persent: 0,
          sum: 0
        },
        fb: {
          name: 'Facebook',
          persent: 0,
          sum: 0
        },
        tw: {
          name: 'Twitter',
          persent: 0,
          sum: 0
        },
        ig: {
          name: 'Instagram',
          persent: 0,
          sum: 0
        },
        tg: {
          name: 'Telegram',
          persent: 0,
          sum: 0
        },
        yt: {
          name: 'Yotube',
          persent: 0,
          sum: 0
        },
        ok: {
          name: 'Одноклассники',
          persent: 0,
          sum: 0
        },
        dz: {
          name: 'Блоги',
          persent: 0,
          sum: 0
        },
        gs: {
          name: 'СМИ',
          persent: 0,
          sum: 0
        },
      },
      negativeArr: {
        vk: {
          name: 'Вконтакте',
          persent: 0,
          sum: 0
        },
        fb: {
          name: 'Facebook',
          persent: 0,
          sum: 0
        },
        tw: {
          name: 'Twitter',
          persent: 0,
          sum: 0
        },
        ig: {
          name: 'Instagram',
          persent: 0,
          sum: 0
        },
        tg: {
          name: 'Telegram',
          persent: 0,
          sum: 0
        },
        yt: {
          name: 'Yotube',
          persent: 0,
          sum: 0
        },
        ok: {
          name: 'Одноклассники',
          persent: 0,
          sum: 0
        },
        dz: {
          name: 'Блоги',
          persent: 0,
          sum: 0
        },
        gs: {
          name: 'СМИ',
          persent: 0,
          sum: 0
        },
      },
      neturalArr: {
        vk: {
          name: 'Вконтакте',
          persent: 0,
          sum: 0
        },
        fb: {
          name: 'Facebook',
          persent: 0,
          sum: 0
        },
        tw: {
          name: 'Twitter',
          persent: 0,
          sum: 0
        },
        ig: {
          name: 'Instagram',
          persent: 0,
          sum: 0
        },
        tg: {
          name: 'Telegram',
          persent: 0,
          sum: 0
        },
        yt: {
          name: 'Yotube',
          persent: 0,
          sum: 0
        },
        ok: {
          name: 'Одноклассники',
          persent: 0,
          sum: 0
        },
        dz: {
          name: 'Блоги',
          persent: 0,
          sum: 0
        },
        gs: {
          name: 'СМИ',
          persent: 0,
          sum: 0
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "socialList",
    ]),
    isLoaded() {
      return this.$store.getters.isLoaded(this.chartName);
    },
    totalData() {
      console.log('this.getData("total")', this.getData("total"))
      //console.log('this', this.fi("total"))
      return this.getData("total");
    },
    neturalData() {
      return this.getData("netural");
    },
    positiveData() {
      return this.getData("positive");
    },
    negativeData() {
      return this.getData("negative");
    },
    totalSum() {
      return this.getSum(this.data.total.total);
    },
    neturalSum() {
      return this.getSum(this.data.total.netural);
    },
    positiveSum() {
      return this.getSum(this.data.total.positive);
    },
    negativeSum() {
      return this.getSum(this.data.total.negative);
    },
  },
  methods: {
    setStatisticItem(to) {
      let statisticElements = document.querySelectorAll('.statistic-content__item');
      const firstElement = statisticElements[0];
      const elementWidth = firstElement.offsetWidth;

      if (to === 'prev') {
        if (this.activeStatisticItem > 0) {
          this.activeStatisticItem = this.activeStatisticItem - 1;
          firstElement.setAttribute("style", `margin-left: -${elementWidth * this.activeStatisticItem}px`);
        }
      } else {
        if (this.activeStatisticItem < statisticElements.length - 1) {
          this.activeStatisticItem = this.activeStatisticItem + 1;
          firstElement.setAttribute("style", `margin-left: -${elementWidth * this.activeStatisticItem}px`);
        }
      }
    },
    getCoverage() {
        const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss"
        const endDate = new Date();
        const startDate = new Date();

        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);

        endDate.setHours(23);
        endDate.setMinutes(59);
        endDate.setSeconds(59);
        const params = {
          thread_id: Number(this.$route.params.threadId),
          from: moment(startDate).format(DATE_FORMAT),
          to: moment(endDate).format(DATE_FORMAT)
        };
        getTrustHourlyApi(params).then(resp => {
          console.log('dd22', resp.data)
          //this.dataFirst={...resp.data}
          this.total = resp.data.total.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.netural = resp.data.total.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positive = resp.data.total.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negative = resp.data.total.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.vk.sum = resp.data.vk.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.dz.sum = resp.data.dz.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.fb.sum = resp.data.fb.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.tw.sum = resp.data.tw.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.tw.sum = resp.data.tw.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.tg.sum = resp.data.tg.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.yt.sum = resp.data.yt.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.ok.sum = resp.data.ok.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.gs.sum = resp.data.gs.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.vk.sum = resp.data.vk.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.dz.sum = resp.data.dz.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.totalArr.ig.sum = resp.data.ig.total.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.ig.sum = resp.data.ig.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.fb.sum = resp.data.fb.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.tw.sum = resp.data.tw.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.tw.sum = resp.data.tw.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.tg.sum = resp.data.tg.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.yt.sum = resp.data.yt.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.ok.sum = resp.data.ok.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.neturalArr.gs.sum = resp.data.gs.netural.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.vk.sum = resp.data.vk.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.dz.sum = resp.data.dz.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.fb.sum = resp.data.fb.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.tw.sum = resp.data.tw.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.tw.sum = resp.data.tw.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.tg.sum = resp.data.tg.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.yt.sum = resp.data.yt.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.ok.sum = resp.data.ok.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.gs.sum = resp.data.gs.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.vk.sum = resp.data.vk.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.dz.sum = resp.data.dz.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.positiveArr.ig.sum = resp.data.ig.positive.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.ig.sum = resp.data.ig.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.fb.sum = resp.data.fb.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.tw.sum = resp.data.tw.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.tw.sum = resp.data.tw.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.tg.sum = resp.data.tg.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.yt.sum = resp.data.yt.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.ok.sum = resp.data.ok.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
          this.negativeArr.gs.sum = resp.data.gs.negative.reduce((sum, current) => {
            return sum + current[1];
          }, 0);
        });
        //return this.dataFirst
      },
    changeSocialList(key) {
      if (this.socialList.length >= 1) {
        this.$store.dispatch(SET_SOCIAL, key);
      }
    },
    getData(tonal) {
      let data = {};
      let sourceShortcuts = this.$t('feed.analytics.statistics.body.shortcuts');
      Object.entries(sourceShortcuts).forEach(shortcut => {
        if(this.data[shortcut[0]]) {
          let sum = this.getSum(this.data[shortcut[0]][tonal]);
          let percent = this.getItemPercentByRound(sum, tonal);

          data[shortcut[0]] = {
            sum,
            name: shortcut[1],
            percent
          };
        }
      });

      return data;
    },
    getItemPercentByRound(sum, tonal) {
      if(this[tonal+"Sum"] === 0) {
        return 0;
      }

      const byModule = ( (sum / this[tonal+"Sum"]) * 100 ) % 1;
      const quotient = sum / this[tonal+"Sum"];

      if(!byModule) {

        if(isNaN(quotient)) {
          return  0;
        }

        return (quotient * 100).toFixed(0);
      }

      return (quotient * 100).toFixed(2);
    },
    getTotalPercent(sum) {
      const byModule = (sum / this.totalSum) % 1;
      const quotient = sum / this.totalSum;

      if(!byModule) {

        if(isNaN(quotient)) {
          return  0;
        }

        return (quotient * 100).toFixed(0);
      }

      return (quotient * 100).toFixed(2);
    },
    getSum(data) {
      return data.reduce((sum, current) => {
        return sum + current[1];
      }, 0);
    }
  },
  mounted(){
    // this.getCoverage()
    //this.getData('total')
  }
};
</script>

<style>
.statistic_container {
  position: relative;
}
.statistic_control {
  display: none;
}
.statistic-content {
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  list-style: none;
}

.statistic-content__item {
  width: 225px;
  font-family: "Roboto", "Arial", sans-serif;
}

.statistic-content__item--common .source-statistic__table-col-header{
  color: #5E6D82;
}

.statistic-content__item--neutral .source-statistic__table-col-header{
  color: #B3BCCC;
}

.statistic-content__item--positive .source-statistic__table-col-header {
  color: #15CF49;
}

.statistic-content__item--negative .source-statistic__table-col-header{
  color: #F75B5B;;
}

.statistic-content__count {
  margin: 0 0 5px 0;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.statistic-content__percent {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #5E6D82;
}

.statistic-content__title {
  display: block;
  margin-bottom: 19px;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;

  color: #B3BCCC;
}

.source-statistic__table {
  width: 100%;
  border-spacing: 0 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;

  color: #5E6D82;
}

.source-statistic__table-col-header {
  vertical-align: baseline;
}

.source-statistic__table-col {
  text-align: left;
}

.source-statistic__table-col-source {
  width: 55%;
  text-align: left;
}

.source-statistic__table-col-count {
  text-align: right;
}
@media screen and (max-width: 480px) {
  .statistic-content {
    width: 100%;
    overflow: hidden;
  }
  .statistic-content__item {
    width: 100%;
    flex-shrink: 0;
  }
  .statistic-content__title {
    height: 50px;
  }
  .statistic_control {
    position: absolute;
    left: 0;
    right: 0;
    top: 75px;
    display: flex;
    justify-content: space-between;
    list-style: none;
    padding: 4px 0 0 0;
    margin: 10px 0 0 0;
    border: 1px solid #c0ccda;
    border-radius: 5px;
  }
}
</style>
